import {ConnectedComponent} from 'lowkey-component';

import {HoverImages} from '@components/helpers/HoverImages';
import {MediaQuery} from '@services/MediaQuery';

export class Contact extends ConnectedComponent<HTMLDivElement> {
  private observer: IntersectionObserver | null = null;
  private mq = MediaQuery.create();
  private hoverImages: HoverImages | null = null;

  private inner: HTMLDivElement | undefined = undefined;
  private imageContainer: HTMLDivElement | undefined = undefined;
  private images: HTMLDivElement[] = [];
  private items: HTMLDivElement[] = [];

  constructor(element: HTMLDivElement) {
    super(element);
    this.onIntersection = this.onIntersection.bind(this);
  }

  didMount() {
    this.imageContainer = this.element.querySelector(
      '.s-contact_images',
    ) as HTMLDivElement;

    if (this.mq.isPhone()) {
      const threshold = 1.0;
      const margin = window.innerHeight / 6;
      this.observer = new IntersectionObserver(this.onIntersection, {
        threshold: threshold,
        rootMargin: `200px 0px -${margin}px`,
      });
      this.observer.observe(this.element);
      return;
    }

    this.inner = this.element.querySelector(
      '.s-contact_inner',
    ) as HTMLDivElement;
    this.images = [
      ...this.element.querySelectorAll('.s-contact_image'),
    ] as HTMLDivElement[];
    this.items = [
      ...this.element.querySelectorAll('.s-contact_inner'),
    ] as HTMLDivElement[];

    this.hoverImages = new HoverImages(
      this.inner,
      this.imageContainer,
      this.images,
      this.items,
      5.55,
    );

    this.hoverImages.init();
  }

  onIntersection(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        this.imageContainer?.classList.add('viewed');
      } else {
        this.imageContainer?.classList.remove('viewed');
      }
    }
  }

  didUnmount() {
    this.observer?.disconnect();
    this.hoverImages?.destroy();
  }
}
